// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"043943c7","163":"2478bfbd","547":"54c934ee","654":"4c6e1ae6","686":"362b509d","787":"64f86a67","969":"96f60634"}[chunkId] + ".chunk.js";
};